import { Component, OnInit,OnDestroy, Input, Inject, ElementRef,HostListener } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ApiService } from 'src/app/pages/common/api.service';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  providers:[ApiService]
})
export class BannerComponent implements OnInit,OnDestroy {
  projectSubscription: Subscription;
  reloadSubscription: Subscription;
  intervalSubscription: Subscription;
  carouselInterval = 5000;
  isAuthenticated: boolean = false;
  pageType = 'default';
  pathname:any;
  isloading = true;
  @HostListener('unloaded')
  ngOnDestroy() {
    this.projectSubscription.unsubscribe()
    this.reloadSubscription.unsubscribe()
    this.intervalSubscription.unsubscribe()
    this.elementRef.nativeElement.remove();
  }
  constructor(
    private _apiService: ApiService,
    public GlobalConstants: GlobalConstants,
    private _auth: AuthenticationService,
    private router: Router,
    private dataTransferService: DataTransferService,
    @Inject(DOCUMENT) private document: any,
    private elementRef: ElementRef
  ) {}

  projectData;
  ngOnInit(): void {
    this.checkPageType()
    this.checkLoggedIn()
    this.getBanners();
    this.intervalSubscription = this.dataTransferService.sharedBannerInterval.subscribe(result => {
      this.carouselInterval = result ? result : this.carouselInterval;
    });
    this.reloadSubscription = this.dataTransferService.sharedReloadEvent.subscribe(res => {
      if(res){
        console.log('reload-banner')
        this.checkPageType();
        this.checkLoggedIn();
        this.getBanners();
      }
    });
  }
  checkPageType(){
    this.pathname = this.document.location.pathname.split('/',3);
    if(this.pathname.length == 3 && this.pathname[2] == 'offers'){
      this.pageType = 'special-benefits';
    }
    else{
      this.pageType = 'default';
    }
  }
  checkLoggedIn(){
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      this.isAuthenticated = true;
    } else {
      this.isAuthenticated = false;
    }
  }

  banners = [];
  bannerData = [];

  getBanners() {
    if(this.projectSubscription){
      this.projectSubscription.unsubscribe()
    }
      this.projectSubscription = this.dataTransferService.sharedMessage.subscribe(result => {
        if(result && result.id){
          this.banners = [];
          this.projectData = result;
          let mainProjectId = this.projectData.id;


          this.projectData.sub_projects.data.forEach((obj) => {
            let subProjectId = obj.id;
            let subProjectCode = obj.attributes.code;
            obj.attributes.project_banners.data.forEach((obj2) => {
              let offerBanner = {
                projectId : subProjectId,
                subProjectCode : subProjectCode,
                attributes: obj2.attributes,
                type: 'sub_project'
              }
              if(this.pageType === 'default'){
                this.banners.push(offerBanner);
              }
              else{
                if(offerBanner.subProjectCode === this.pathname[1]){
                  this.banners.push(offerBanner);
                }
              }
            });
          });
          if(this.pageType === 'default' || this.banners.length == 0){
            this.projectData.project_banners.data.forEach((obj) => {
              let projectBanner = {
                projectId : mainProjectId,
                attributes: obj.attributes,
                type: 'main_project'
              }
              this.banners.unshift(projectBanner);
            });
          }
          this.isloading = false;
        }

      });

  }

  getBannerUrl(banner) {
    if(this.isAuthenticated){
      if(banner.type == "sub_project"){
        this.router.navigate([`/${banner.subProjectCode}/offers`])
      }
    }else{
      this.carouselInterval = -1;
      localStorage.setItem('redirectData', JSON.stringify(banner));
      this._auth.errorEvent.emit(true);
    }
  }
}
